import {AxiosResponse} from "axios"
import AxiosServiceHandler from "./AxiosServiceHandler";

interface AutocompleteDataType {
    pageNumber: number,
    pageSize: number,
    productCategory: string,
    productName: string,
    mission: string,
    scope: string,
    fieldName: string,
    fieldValue: string,
    profile: string,
}

interface AutocompleteResponseType {
    totalItems: number,
    pageNumber: number,
    pageSize: number,
    totalPages: number,
    values: string[],
}

class ApplicationService extends AxiosServiceHandler {
  static getConfigurations() {
    return this.getInstance().get(`${process.env.REACT_APP_DJANGO_HOME}${process.env.REACT_APP_DJANGO_CONFIGURATION_ENDPOINT}`)
  }

  static searchDataMap(searchData, filters) {
    const url = "http://exampleMap.com/search";
    const data = {
      searchdata: searchData,
      filters: {
        beam_number: filters.beam_number || null,
        incidence_angle: filters.incidence_angle || null,
        interferometric_stack: filters.interferometric_stack || null,
        lookside: filters.lookside || null,
        orbit_direction: filters.orbit_direction || null,
        platforms: filters.platforms || null,
        polarization: filters.polarization || null,
        tiles_id: filters.tiles_id || null,
      },
    };
    return this.getInstance().post(url, data);
  }

  static platformProcessing(arr1) {
    const platforms: string[] = [];
    arr1.forEach((element) => {
      if (element === "COSMO-SkyMed (I Generation)") {
        platforms.push("CSK1");
      } else if (element === "COSMO-SkyMed (II Generation)") {
        platforms.push("CSK2");
      }
    });
    return platforms;
  }

  static searchDataJsonBuilder(searchData, isInterferometricStackSearch) {
    // Conversione in GeoJSON (feature)
    let shapeData;
    if (searchData.polygon !== undefined) {
      shapeData = {type: "Polygon", coordinates: searchData.polygon}
    } else if (searchData.circle !== undefined) {
      shapeData = {
        type: "Feature",
        properties: {radius: searchData.circle.radius},
        geometry: {type: "Point", coordinates: searchData.circle.center}
      }
    }

    const data: any = {
      collections: [searchData.routine ? "MapItaly Routine" : "MapItaly L0"],
      filters: {
        mission: searchData.missions,
      },
      ids: searchData.ids,
      intersects: shapeData,
      limit: searchData.pageSize,
      sortby:
      [{
        direction: searchData.orderBy.sortType.toLowerCase(),
        field: `properties.${searchData.orderBy.fieldName}`
      }]
    };

    // serve per gestire la paginazione
    if (searchData.token) {
      data.token = searchData.token;
    }

    if (searchData.from && searchData.to) {
      data.datetime = `${searchData.from}/${searchData.to}`;
    } else if (searchData.from) {
      data.datetime = `${searchData.from}/`;
    } else if (searchData.to) {
      data.datetime = `/${searchData.to}`;
    }

    if (isInterferometricStackSearch) {
      data.filters.interferometric_stack = true;
    }

    if (searchData.product_identifier) {
      data.tiles_id = searchData.product_identifier;
    }

    // per convertire il formato con cui inviamo i filtri avanzati
    Object.keys(searchData.filters).forEach((key) => {
      let value: any = null;
      if (searchData.filters[key].hasOwnProperty("value") && searchData.filters[key].value && (!Array.isArray(searchData.filters[key].value) || searchData.filters[key].value.length > 0)) {
        if (key === "lookside") {
          value = searchData.filters[key].value[0];
        } else if (!Array.isArray(searchData.filters[key].value)) {
          value = [searchData.filters[key].value];
        } else {
          value = searchData.filters[key].value;
        }
      } else if (!searchData.filters[key].hasOwnProperty("value") && searchData.filters[key] && (!Array.isArray(searchData.filters[key]) || searchData.filters[key].length > 0)) {
        value = searchData.filters[key];
      }
      if (value !== null) {
        data.filters[key] = value;
      }
    });

    // se ho tra i filtri sia beam che incidence_angle, cancello incidence_angle
    if (data.filters.beam && data.filters.incidence_angle) {
      delete data.filters.incidence_angle;
    }

    // gestione download risultati di ricerca
    if (searchData.formats && searchData.formats.length) {
      data.type_of_download = searchData.formats[0];
      if (searchData.aoi) {
        data.download_aoi = true; // TODO: mappare flag corretto
      }
      if (searchData.selectedResults) {
        // override degli ids da "cercare"
        data.ids = searchData.selectedProducts.map((product) => product.id);
      }
      if (searchData.allResults) {
        // se li voglio tutti non devo paginare
        data.filters.no_pagination = true;
      }
    }

    return data;
  }

  static searchData(searchData, isInterferometricStackSearch = false) {
    const url = `${process.env.REACT_APP_MAPIT}${process.env.REACT_APP_MAPIT_SEARCH}`;
    const data = ApplicationService.searchDataJsonBuilder(searchData, isInterferometricStackSearch)
    return this.getInstance().post(url, data);
  }

  static downloadSearchResults(url, data) {
    // const accessToken = sessionStorage.getItem("jwtAuth");
    // const requestOptions = {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer ${accessToken}`,
    //     Accept: "application/json"
    //   },
    //   body: JSON.stringify(data),
    // };
    // return fetch(url, requestOptions);
    return this.getInstance().post(url, data, { responseType: "blob" });
  }
//MAPIT-BUGFIX-INVALIDATE
  static invalidateReprocessSearchData(searchData) {
    const url = `${process.env.REACT_APP_MAPIT}${process.env.REACT_APP_MAPIT_SEARCH}`;

    const data: any = {
      collections: [searchData.routine ? "MapItaly Routine" : "MapItaly L0"],
      filters: {
        mission: searchData.missions,
        no_pagination: true,
      },
      invalidate_search: searchData.invalidate_search,
      invalidate_mode: searchData.invalidate_mode
    };

    if (searchData.from && searchData.to) {
      data.datetime = `${searchData.from}/${searchData.to}`;
    } else if (searchData.from) {
      data.datetime = `${searchData.from}/`;
    } else if (searchData.to) {
      data.datetime = `/${searchData.to}`;
    }

    // per convertire il formato con cui inviamo i filtri avanzati
    Object.keys(searchData.filters).forEach((key) => {
      let value: any = null;
      if (searchData.filters[key].hasOwnProperty("value") && searchData.filters[key].value && (!Array.isArray(searchData.filters[key].value) || searchData.filters[key].value.length > 0)) {
        if (key === "lookside") {
          value = searchData.filters[key].value[0];
        } else if (!Array.isArray(searchData.filters[key].value)) {
          value = [searchData.filters[key].value];
        } else {
          value = searchData.filters[key].value;
        }
      } else if (!searchData.filters[key].hasOwnProperty("value") && searchData.filters[key] && (!Array.isArray(searchData.filters[key]) || searchData.filters[key].length > 0)) {
        value = searchData.filters[key];
      }
      if (value !== null) {
        data.filters[key] = value;
      }
    });

    return this.getInstance().post(url, data);
  }

  static autocomplete(data: AutocompleteDataType): Promise<AxiosResponse<AutocompleteResponseType>> {
    return this.getInstance()
      .post(
        `${process.env.REACT_APP_MAPIT}${process.env.REACT_APP_MAPIT_AUTOCOMPLETE}`,
        data
      );
  }
}

export default ApplicationService;
